module.exports = __webpack_public_path__ + "img/hitachi-digital-host-2.1fe76aa9.png";